import React from "react";
import ReactDOM from "react-dom";
import "./CSS/index.css";
import App from "./Components/App";
import reportWebVitals from "./reportWebVitals";
import "./CSS/mycss.css";
import { QueryClient, QueryClientProvider } from "react-query";

 if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') {
   window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
 }

const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </QueryClientProvider>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
